import { useState, useEffect } from "react";

const useSmallScreenView = (breakpoint: number) => {
  const [isSmallScreen, setIsSmallScreen] = useState(
    window.innerWidth <= breakpoint
  );
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= breakpoint);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isSmallScreen;
};

export default useSmallScreenView;
